/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Order types the public create-order route can execute and persist today.  The canonical engine enum is deliberately broader; using it directly in OpenAPI advertised fifteen values that this route always rejects before either its live or paper execution branch.
 */
export enum OrderCreateType {

    Market = 'market',

    Limit = 'limit',

    Stop = 'stop',

    StopLimit = 'stop_limit'
}
